import { useRouterListStore } from '@/stores/routers';
import storage from './storage';

// 获取路由地址
export const getRouterList = () => {
  return useRouterListStore().routerList;
};
export const setRouterList = (list) => {
  return useRouterListStore().setRouterList(list);
};
// 获取权限
export const getAuthenticatedList = () => {
  return useRouterListStore().authenticatedList;
};
export const setAuthenticatedList = (list) => {
  return useRouterListStore().setAuthenticatedList(list);
};

// 获取用户数据
export function getSession() {
  return storage.get('session');
}

export function clearSession() {
  return storage.remove('session');
}

export function updateSession(data) {
  storage.set('session', Object.assign({}, getSession(), data));
}
